// Shared time formatting for TurantChat (user widget + admin inbox).
// Messages store `at`/`lastAt` as UTC ISO strings — always render them in the
// viewer's local zone (IST) via Date, never by slicing the ISO string.

// Per-message time, e.g. "3:42 PM".
export function fmtChatTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return isNaN(d) ? "" : d.toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit", hour12: true });
}

// Date-separator label between days: "Today" / "Yesterday" / "5 Jul 2026".
export function fmtChatDateSep(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  const today = new Date();
  const yest = new Date();
  yest.setDate(today.getDate() - 1);
  if (d.toDateString() === today.toDateString()) return "Today";
  if (d.toDateString() === yest.toDateString()) return "Yesterday";
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
}

// Chat-list row timestamp: today → time, otherwise short date (local).
export function fmtChatListWhen(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  return d.toDateString() === new Date().toDateString()
    ? fmtChatTime(iso)
    : d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
}

// True if two ISO timestamps fall on the same local day.
export function sameLocalDay(a, b) {
  if (!a || !b) return false;
  const da = new Date(a), db = new Date(b);
  return !isNaN(da) && !isNaN(db) && da.toDateString() === db.toDateString();
}
